import { FC, useEffect } from 'react';

import { Flex, Form, Select } from 'antd';

import { StorageType } from '@/constants';
import { SimulationResult } from '@/types/simulations';

interface SelectMetricProps {
  selectedSimulations: SimulationResult[];
  selectedMetric: string;
  selectedTimeFrame: string;
  onMetricChange: (value: string) => void;
  onTimeFrameChange: (value: string) => void;
}

interface FormValues {
  metric: string;
  timeFrame: string;
}

const SelectMetric: FC<SelectMetricProps> = ({
  selectedMetric,
  selectedTimeFrame,
  onMetricChange,
  onTimeFrameChange,
}) => {
  const [form] = Form.useForm<FormValues>();

  useEffect(() => {
    form.setFieldsValue({
      metric: selectedMetric,
      timeFrame: selectedTimeFrame,
    });
  }, [form, selectedMetric, selectedTimeFrame]);

  const handleFinish = (values: FormValues) => {
    onMetricChange(values.metric);
    onTimeFrameChange(values.timeFrame);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{
        metric: selectedMetric,
        timeFrame: selectedTimeFrame,
      }}
    >
      <Flex vertical justify="space-between">
        <Form.Item
          name="metric"
          label="Select Metric"
          rules={[{ required: true, message: 'Please select a metric' }]}
        >
          <Select
            placeholder="Select a metric"
            onChange={(value) => onMetricChange(value)}
          >
            <Select.Option value="irr">IRR</Select.Option>
            <Select.Option value="ebitda">EBITDA Margin</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="timeFrame"
          label="Select Storage Type"
          rules={[{ required: true, message: 'Please select a storage type' }]}
        >
          <Select
            placeholder="Select a storage type"
            onChange={(value: StorageType) => onTimeFrameChange(value)}
          >
            {Object.entries(StorageType).map(([key, value]) => (
              <Select.Option key={value} value={value}>
                {key
                  .split('_')
                  .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                  .join(' ')}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Flex>
    </Form>
  );
};

export default SelectMetric;
